/**
 * ScrollToTop Component
 * Automatically scrolls to top of page on route change
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        // Scroll to top whenever route changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant' // Instant scroll, no animation
        });
    }, [pathname]);
    return null;
};
